<script setup lang="ts">
const { lazy = true } = defineProps<{
  banner: any
  lazy?: boolean
}>()
</script>

<template>
  <article
    v-if="banner"
    class="product-banner"
  >
    <h3
      v-if="banner?.Title"
      class="product-banner__heading"
    >
      <AppLink
        v-if="banner?.File?.Link"
        class="product-banner__link"
        :to="banner?.File?.Link"
      >
        {{ banner.Title }}
      </AppLink>
    </h3>

    <p
      v-if="banner?.Description"
      class="product-banner__description"
    >
      {{ banner.Description }}
    </p>

    <div
      v-if="banner?.ButtonText"
      class="product-banner__button"
    >
      <span>{{ banner?.ButtonText }}</span>
    </div>

    <div class="product-banner__visual">
      <picture
        v-if="banner?.File?.Media?.url && banner?.File?.Media?.mime?.includes('image')"
        class="banner__picture"
      >
        <source
          :srcset="`${banner?.File?.Media?.url?.replaceAll(' ', '%20')}`"
          media="(min-width: 768px)"
        >
        <source
          :srcset="`${banner?.File?.MediaMobile?.url?.replaceAll(' ', '%20') || banner?.File?.Media?.url?.replaceAll(' ', '%20')}`"
        >
        <img
          class="product-banner__image"
          :src="banner?.File?.Media?.url?.replaceAll(' ', '%20')"
          :alt="banner?.File?.Media?.alternativeText || banner?.Name || ''"
          :width="banner?.File?.Media?.width"
          :height="banner?.File?.Media?.height"
          :loading="lazy ? 'lazy' : 'eager'"
          :fetchpriority="lazy ? 'low' : 'high'"
          :decoding="lazy ? 'async' : 'sync'"
        >
      </picture>
      <div
        v-else-if="banner?.File?.Media?.url && banner?.File?.Media?.mime?.includes('video')"
        class="product-banner__video"
      >
        <UiVideo
          v-if="banner?.File?.Media?.url"
          :class="{ 'mq--desktop-plus': banner?.File?.Media?.url && banner?.File?.MediaMobile?.url }"
          :src="banner?.File?.Media?.url"
          :alt="banner?.File?.Media?.alternativeText || banner?.Name"
          :width="banner?.File?.Media?.width"
          :height="banner?.File?.Media?.height"
          :loading="lazy ? 'lazy' : 'eager'"
          :fetchpriority="lazy ? 'auto' : 'high'"
          :controls="false"
          autoplay
          muted
          loop
        />
        <UiVideo
          v-if="banner?.File?.MediaMobile?.url && banner?.File?.MediaMobile?.mime?.includes('video')"
          class="mq--mobile-phablet"
          :src="banner?.File?.MediaMobile?.url"
          :alt="banner?.File?.MediaMobile?.alternativeText || banner?.Name"
          :width="banner?.File?.MediaMobile?.width"
          :height="banner?.File?.MediaMobile?.height"
          :loading="lazy ? 'lazy' : 'eager'"
          :fetchpriority="lazy ? 'auto' : 'high'"
          :controls="false"
          autoplay
          muted
          loop
        />
      </div>
    </div>
  </article>
</template>

<style src="~layers/app/components/Catalog/GridBanner.css" />
